import { ChangeEvent, FC } from "react";

import { Box, chakra } from "@chakra-ui/react";
import { i18n, Trans, useTranslation } from "next-i18next";

import Checkbox from "@components/Checkbox";

import { OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";

const Agreements: FC = () => {
  const { t } = useTranslation();

  const {
    values: { [OrderFields.TERMS_AGREEMENT]: hasTermsAgreement },
    errors,
    touched,
    setFieldValue,
  } = useOrderFormik();

  const isTermsAgreementTouched = touched[OrderFields.TERMS_AGREEMENT];
  const termsAgreementError = errors[OrderFields.TERMS_AGREEMENT];

  const handleTermsCheckboxChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(OrderFields.TERMS_AGREEMENT, checked);
  };

  return (
    <Box borderTop="1px solid" borderColor="grey.light" py="1.5rem" data-field={OrderFields.TERMS_AGREEMENT}>
      <Checkbox
        isFormik={false}
        size="sm"
        isChecked={!!hasTermsAgreement}
        onChange={handleTermsCheckboxChange}
        isInvalid={isTermsAgreementTouched && !!termsAgreementError}
        message={termsAgreementError}
      >
        <chakra.span fontSize="0.875rem">
          <Trans
            i18n={i18n!}
            i18nKey="order-summary-agreement"
            components={{
              instructions: (
                <chakra.a
                  href={t("order-summary-agreement-packaging_instructions_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
              terms: (
                <chakra.a
                  href={t("order-summary-agreement-general_terms_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
              privacy: (
                <chakra.a
                  href={t("order-summary-agreement-privacy_href")}
                  target="_blank"
                  color="red.lead"
                  sx={{ _hover: { textDecoration: "underline" } }}
                />
              ),
            }}
          />
        </chakra.span>
      </Checkbox>
    </Box>
  );
};
export default Agreements;
